const state = {
  tutorial: {},
  tutorials: [],
  myTutorials: []
}

const getters = {
  myTutorials (state) {
    return state.myTutorials
  },
  tutorial (state) {
    return state.tutorial
  },
  tutorials (state) {
    return state.tutorials
  }
}

const mutations = {
  SET_MY_TUTORIALS (state, payload) {
    state.myTutorials = payload
  },
  SET_TUTORIAL (state, payload) {
    state.tutorial = payload
  },
  SET_TUTORIALS (state, payload) {
    state.tutorials = payload
  },
  DELETE_TUTORIAL (state, payload) {
    state.tutorials = state.tutorials.filter((tutorial) => {
      return tutorial.id !== payload
    })
  },
  UPDATE_TUTORIAL (state, payload) {
    state.tutorials = state.tutorials.map((tutorial) => {
      if (tutorial.id === payload.id) {
        tutorial.name = payload.name
        tutorial.position = payload.position
        tutorial.video = payload.video
        tutorial.lang = payload.lang
      }
      return tutorial
    })
  },
  ADD_TUTORIAL (state, payload) {
    state.tutorials.push(payload)
  }
}

const actions = {
  SET_MY_TUTORIALS (context, payload) {
    context.commit('SET_MY_TUTORIALS', payload)
  },
  DELETE_TUTORIAL (context, payload) {
    context.commit('DELETE_TUTORIAL', payload)
  },
  ADD_TUTORIAL (context, payload) {
    context.commit('ADD_TUTORIAL', payload)
  },
  UPDATE_TUTORIAL (context, payload) {
    context.commit('UPDATE_TUTORIAL', payload)
  },
  SET_TUTORIAL (context, payload) {
    context.commit('SET_TUTORIAL', payload)
  },
  SET_TUTORIALS (context, payload) {
    context.commit('SET_TUTORIALS', payload)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
